import { combineReducers } from 'redux';
import organizationsReducer from './organizationsReducer';
import searchOrganizationsReducer from './searchOrganizationsReducer';
import getOrganizationsReducer from './getOrganizationsReducer';
import getOrganizationBySlugReducer from './getOrganizationBySlugReducer';

export default combineReducers({
  organizationsState: organizationsReducer,
  searchOrganizationsState: searchOrganizationsReducer,
  getOrganizationsState: getOrganizationsReducer,
  organizationBySlugState: getOrganizationBySlugReducer,
});
